import { EventEmitter } from '../util/eventemitter';

export class VendingData extends EventEmitter {
  mode: 'closed' | 'setup' | 'open';
  title: string;
  mySellItems: Map<number, any>;
  myBuyItems: Map<number, any>;
  browsing: { ownerClientId: number; ownerName: string; sellItems: Map<number, any>; buyItems: Map<number, any>; title: string } | null;
  pendingBrowseOwnerId: number | null;

  constructor() {
    super();
    this.mode = 'closed';
    this.title = '';
    this.mySellItems = new Map();
    this.myBuyItems = new Map();
    this.browsing = null;
    this.pendingBrowseOwnerId = null;
  }

  startSetup() {
    if (this.mode === 'closed') {
      this.mode = 'setup';
      this.title = `${MC.name}'s shop`;
      this.mySellItems = new Map();
      this.myBuyItems = new Map();
    }
    this.emit('changed');
  }

  setMySellItem(slotNum: number, item: any, price: number, quantity: number) {
    this.mySellItems.set(slotNum, { item, price, quantity });
    this.emit('changed');
  }

  removeMySellItem(slotNum: number) {
    this.mySellItems.delete(slotNum);
    this.emit('changed');
  }

  setMyBuyItem(slotNum: number, item: any, price: number, desiredQty: number) {
    this.myBuyItems.set(slotNum, { item, price, desiredQty });
    this.emit('changed');
  }

  removeMyBuyItem(slotNum: number) {
    this.myBuyItems.delete(slotNum);
    this.emit('changed');
  }

  confirmOpen(title: string) {
    this.mode = 'open';
    this.title = title;
    this.emit('changed');
  }

  close() {
    this.mode = 'setup';
    this.emit('changed');
  }

  requestBrowse(ownerClientId: number) {
    this.pendingBrowseOwnerId = ownerClientId;
  }

  setBrowsing(data: { ownerClientId: number; ownerName: string; sellItems: Map<number, any>; buyItems: Map<number, any>; title: string }) {
    this.browsing = data;
    this.emit('changed');
  }

  clearBrowsing() {
    this.browsing = null;
    this.pendingBrowseOwnerId = null;
    this.emit('changed');
  }
}
